import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Algo ha salido mal.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export const TYPE_OPTIONS = [
  { value: "pensamiento", label: "Pensamiento", main: "Prosa" },
  { value: "relato", label: "Relato", main: "Prosa" },
  { value: "microrelato", label: "Microrelato", main: "Prosa" },
  { value: "poema", label: "Poema", main: "Versos" },
];

export const SUBCATEGORY_BY_TYPE = {
  pensamiento: "Pensamientos",
  relato: "Relatos",
  microrelato: "Microrelatos",
  poema: "Poemas",
};
